import { StoryData } from "./StoryData";
import { FormDesignerStories } from "../../Form/Stories/XFormDesigner-stories";
import { FormDesignerRuleStories } from "../../Form/Stories/XFormRule-stories";
import { FormUserStories } from "../../Form/Stories/XUserForm-stories";
import { BarChartStories } from "../../Form/Controls/Stories/XBarChart-stories";
import { ButtonStories } from "../../Form/Controls/Stories/XButton-stories";
import { ButtonGroupStories } from "../../Form/Controls/Stories/XButtonGroup-stories";
import { CheckBoxStories } from "../../Form/Controls/Stories/XCheckboxField-stories";
import { CheckboxListStories } from "../../Form/Controls/Stories/XCheckboxList-stories";
import { ColorPickerStories } from "../../Form/Controls/Stories/XColorPicker-stories";
import { CurrencyFieldStories } from "../../Form/Controls/Stories/XCurrencyField-stories";
import { DataGridStories } from "../../Form/Controls/Stories/XDataGrid-stories";
import { DatePickerStories } from "../../Form/Controls/Stories/XDatePicker-stories";
import { DateRangeStories } from "../../Form/Controls/Stories/XDateRange-stories";
import { FileDownloadStories } from "../../Form/Controls/Stories/XFileDownload-stories";
import { FileUploadStories } from "../../Form/Controls/Stories/XFileUpload-stories";
import { HeadingStories } from "../../Form/Controls/Stories/XHeading-stories";
import { ImageControlStories } from "../../Form/Controls/Stories/XImageControl-stories";
import { InlineRichEditFormStories } from "../../Form/Controls/Stories/XInlineRichTextEdit-stories";
import { InlineTextEditStories } from "../../Form/Controls/Stories/XInlineTextEdit-stories";
import { LabelStories } from "../../Form/Controls/Stories/XLabel-stories";
import { LineChartStories } from "../../Form/Controls/Stories/XLineChart-stories";
import { LineControlStories } from "../../Form/Controls/Stories/XLineControl-stories";
import { LinkStories } from "../../Form/Controls/Stories/XLink-stories";
import { ListEntryStories } from "../../Form/Controls/Stories/XListEntry-stories";
import { MultiInlineTextEditStories } from "../../Form/Controls/Stories/XMultiInlineTextEdit-stories";
import { MultiLineTextEditStories } from "../../Form/Controls/Stories/XMultiLineTextEdit-stories";
import { NumberBoxStories } from "../../Form/Controls/Stories/XNumberBox-stories";
import { PasswordBoxStories } from "../../Form/Controls/Stories/XPasswordBox-stories";
import { PieChartStories } from "../../Form/Controls/Stories/XPieChart-stories";
import { RadioGroupStories } from "../../Form/Controls/Stories/XRadioGroup-stories";
import { RatingStories } from "../../Form/Controls/Stories/XRating-stories";
import { SelectBoxStories } from "../../Form/Controls/Stories/XSelectBox-stories";
import { SignaturePadStories } from "../../Form/Controls/Stories/XSignaturePad-stories";
import { SliderStories } from "../../Form/Controls/Stories/XSlider-stories";
import { SwitchStories } from "../../Form/Controls/Stories/XSwitch-stories";
import { TagGroupStories } from "../../Form/Controls/Stories/XTagGroup-stories";
import { TextFieldStories } from "../../Form/Controls/Stories/XTextField-stories";
import { TimelineStories } from "../../Form/Controls/Stories/XTimeline-stories";
import { TimePickerStories } from "../../Form/Controls/Stories/XTimePicker-stories";
import { ValueSliderStories } from "../../Form/Controls/Stories/XValueSlider-stories";
import { DateExpressionStories } from "../../Expressions/Stories/ExpressionDate-stories";
import { ExpressionEditorStories } from "../../Expressions/Stories/ExpressionEditor-stories";
import { ExpressionLogicStories } from "../../Expressions/Stories/ExpressionLogic-stories";
import { ExpressionMathStories } from "../../Expressions/Stories/ExpressionMath-stories";
import { ExpressionStringStories } from "../../Expressions/Stories/ExpressionString-stories";
import { ExpressionViewStories } from "../../Expressions/Stories/ExpressionView-stories";
import { ExpressionViewStringStories } from "../../Expressions/Stories/ExpressionView.String-stories";
import { ExpressionViewMathStories } from "../../Expressions/Stories/ExpressionView.Math-stories";
import { ExpressionViewLogicStories } from "../../Expressions/Stories/ExpressionView.Logic-stories";
import { ContainerColumnStories } from "../../Form/Containers/XColumnContainer-stories";
import { ContaineGridStories } from "../../Form/Containers/XGridContainer-stories";
import { ContainerHStackStories } from "../../Form/Containers/XHStackContainer-stories";
import { ContainerStackStories } from "../../Form/Containers/XStackContainer-stories";
import { ContainerTabStories } from "../../Form/Containers/XTabContainer-stories";

import { PropertyEditorCollapsableSectionStories } from "../PropertyEditing/stories/PropertyEditorCollapsableSection-stories";
import { PropertyEditorExpressionStories } from "../PropertyEditing/stories/PropertyEditorExpression-stories";
import { PropertyEditorVariableSelectionStories } from "../PropertyEditing/stories/PropertyEditorVariableSelection-stories";
import { PropertyEditorTypeSelectionStories } from "../PropertyEditing/stories/PropertyEditorTypeSelection-stories";
import { BooleanDataEditorStories } from "../DataEditing/Stories/BooleanDataDefinition-stories";
import { BooleanListDataEditorStories } from "../DataEditing/Stories/BooleanListDataDefinition-stories";
import { DataEditorStories } from "../DataEditing/Stories/DateDataDefinition-stories";
import { DataListEditorStories } from "../DataEditing/Stories/DateListDataDefinition-stories";
import { FileEditorStories } from "../DataEditing/Stories/FileDataDefinition-stories";
import { FileListEditorStories } from "../DataEditing/Stories/FileListDataDefinition-stories";
import { NumberEditorStories } from "../DataEditing/Stories/NumberDataDefinition-stories";
import { StringEditorStories } from "../DataEditing/Stories/StringDataDefinition-stories";
import { NumberListEditorStories } from "../DataEditing/Stories/NumberListDataDefinition-stories";
import { StringListEditorStories } from "../DataEditing/Stories/StringListDataDefinition-stories";
import { StringListValidValuesEditorStories } from "../DataEditing/Stories/StringListValidValuesDataDefinition-stories";
import { StringValidValuesEditorStories } from "../DataEditing/Stories/StringValidValuesDataDefinition-stories";
import { ObjectEditorStories } from "../DataEditing/Stories/ObjectDataDefinition-stories";
import { ObjectListEditorStories } from "../DataEditing/Stories/ObjectListDataDefinition-stories";
import { ValueOrExpressionStories } from "../DataEditing/Stories/XValueOrExpressionEditor-stories";
import { MappingEditorStories } from "../../Mapping/Stories/XMappingEditor-stories";
import { BooleanPropertyEditor } from "../PropertyEditing/stories/PropertyEditorBoolean-stories";
import { DatePropertyEditor } from "../PropertyEditing/stories/PropertyEditorDate-stories";
import { FloatPropertyEditor } from "../PropertyEditing/stories/PropertyEditorFloat-stories";
import { ColorPropertyEditor } from "../PropertyEditing/stories/PropertyEditorColor-stories";
import { ImagePropertyEditor } from "../PropertyEditing/stories/PropertyEditorImage-stories";
import { IntegerPropertyEditor } from "../PropertyEditing/stories/PropertyEditorInteger-stories";
import { SelectPropertyEditor } from "../PropertyEditing/stories/PropertyEditorSelect-stories";
import { TextPropertyEditor } from "../PropertyEditing/stories/PropertyEditorText-stories";
import { TextListPropertyEditor } from "../PropertyEditing/stories/PropertyEditorTextList-stories";
import { PropertyEditorTextSelection } from "../PropertyEditing/stories/PropertyEditorTextSelection";
import { ExpressionTester } from "../Testing/Stories/XExecutableTester.Expression-stories";
import { FormTester } from "../Testing/Stories/XExecutableTester.Form-stories";
import { IntersectionTester } from "../Testing/Stories/XExecutableTester.Intersection-stories";
import { RuleTableTester } from "../Testing/Stories/XExecutableTester.RuleTable-stories";
import { StatementRuleTester } from "../Testing/Stories/XExecutableTester.Statementrule-stories";
import { TreeRuleTester } from "../Testing/Stories/XExecutableTester.Tree-stories";
import { ValueTableTester } from "../Testing/Stories/XExecutableTester.ValueTable-stories";
import { DataTypePickerStories } from "../DataTypePicker/DataTypePicker-stories";
import { InlineOptionSelectStories } from "../InlineEditor/InlineOptionSelect-stories";
import { InlineTextEditSelectStories } from "../InlineEditor/InlineTextEditor-stories";
import { InlineMuliLineSelectStories } from "../InlineEditor/MultiInlineTextEdit-stories";
import { VariablePickerStories } from "../VariablePicker/VariablePicker-stories";
import { FlowBuilderStories } from "../../Flow/Stories/XFlowEditor-stories";
import { IntersectionRuleStories } from "../../Rule/Intersection/Stories/IntersectionRuleEditor-stories";
import { StatementRuleStories } from "../../Rule/Statement/Stories/StatementRuleEditor-stories";
import { RuleTableStories } from "../../Rule/Table/RuleTable/Stories/RuleTableEditor-stories";
import { TreeRuleStories } from "../../Rule/Tree/Stories/TreeRuleEditor-stories";
import { ValueTableBooleanStories } from "../../Rule/Table/ValueTable/Stories/ValueTableEditor.booleans-stories";
import { ValueTableDateStories } from "../../Rule/Table/ValueTable/Stories/ValueTableEditor.dates-stories";
import { ValueTableStringStories } from "../../Rule/Table/ValueTable/Stories/ValueTableEditor.string-stories";
import { ValueTableStories } from "../../Rule/Table/ValueTable/Stories/ValueTableEditor-stories";
import { FlowBuilderExpressionStepStories } from "../../Flow/Steps/Expressions/ExpressionSteps-stories";
import { CombinedPropertyEditors } from "../PropertyEditing/stories/AllPropertyEditor-stories";
import { FlowBuilderRuleStepsStories } from "../../Flow/Steps/Rules/Stories/RuleSteps-stories";
import { FlowBuilderFormStepsStories } from "../../Flow/Steps/UI/Stories/FormStep-stories";
import { FormLayoutStories } from "../../Form/Containers/AllContainer-stories";
import { FormAndLayoutDesignPanelStories } from "../../Form/Utilities/XFormAndLayoutDesignPanel-stories";
import { ValueTableNumberStories } from "../../Rule/Table/ValueTable/Stories/ValueTableEditor.numbers-stories";
import { DataDefinitionEditorStories } from "../../DataBuilder/DataBuilder-stories";
import { ObserveStateStories } from "../StateManagement/ObserveState.stories";
import { CustomTextMergeBuilder } from "../../TextMerge/TextMerge.stories";
import { BuildlingBlockStories } from "../BuildlingBlocks/BuildingBlocks.stories";
import { OpenAIStories } from "../OpenAI/OpenAI.stories";
import { RichTextEditorFormControlsStories } from "../../Form/Controls/Stories/XRichTextEditor-stories";
import { RichTextEditorStories } from "../RichTextEditor/RichTextEditor-stories";
import { ObjectListPropertyEditorStories } from "../PropertyEditing/stories/PropertyEditorObjectList-stories";
import { CollapsePropertyEditorStories } from "../PropertyEditing/stories/PropertyEditorCollapse-stories";
import { InlineRichEditStories } from "../InlineEditor/InlineRichTextEditor-stories";
import { ColorStories } from "../BuildlingBlocks/Color.stories";

export function RegisterStories() {
    StoryData.addNodes(ColorStories);

    // form designer
    StoryData.addNodes(FormDesignerStories);
    StoryData.addNodes(FormDesignerRuleStories);
    StoryData.addNodes(FormUserStories);
    StoryData.addNodes(FormLayoutStories);
    StoryData.addNodes(FormAndLayoutDesignPanelStories);

    // form controls
    StoryData.addNodes(BarChartStories);
    StoryData.addNodes(ButtonStories);
    StoryData.addNodes(ButtonGroupStories);
    StoryData.addNodes(CheckBoxStories);
    StoryData.addNodes(CheckboxListStories);
    StoryData.addNodes(ColorPickerStories);
    StoryData.addNodes(CurrencyFieldStories);
    StoryData.addNodes(DataGridStories);
    StoryData.addNodes(DatePickerStories);
    StoryData.addNodes(DateRangeStories);
    StoryData.addNodes(FileDownloadStories);
    StoryData.addNodes(FileUploadStories);
    StoryData.addNodes(HeadingStories);
    StoryData.addNodes(ImageControlStories);
    StoryData.addNodes(InlineRichEditFormStories);
    StoryData.addNodes(InlineTextEditStories);
    StoryData.addNodes(LabelStories);
    StoryData.addNodes(LineChartStories);
    StoryData.addNodes(LineControlStories);
    StoryData.addNodes(LinkStories);
    StoryData.addNodes(ListEntryStories);
    StoryData.addNodes(MultiInlineTextEditStories);
    StoryData.addNodes(MultiLineTextEditStories);
    StoryData.addNodes(NumberBoxStories);
    StoryData.addNodes(PasswordBoxStories);
    StoryData.addNodes(PieChartStories);
    StoryData.addNodes(RadioGroupStories);
    StoryData.addNodes(RatingStories);
    StoryData.addNodes(RichTextEditorFormControlsStories);
    StoryData.addNodes(SelectBoxStories);
    StoryData.addNodes(SignaturePadStories);
    StoryData.addNodes(SliderStories);
    StoryData.addNodes(SwitchStories);
    StoryData.addNodes(TagGroupStories);
    StoryData.addNodes(TextFieldStories);
    StoryData.addNodes(TimelineStories);
    StoryData.addNodes(TimePickerStories);
    StoryData.addNodes(ValueSliderStories);

    // form container stories
    StoryData.addNodes(ContainerColumnStories);
    StoryData.addNodes(ContaineGridStories);
    StoryData.addNodes(ContainerHStackStories);
    StoryData.addNodes(ContainerStackStories);
    StoryData.addNodes(ContainerTabStories);
    StoryData.addNodes(ContainerColumnStories);

    // expression stories
    StoryData.addNodes(ExpressionEditorStories);
    StoryData.addNodes(DateExpressionStories);
    StoryData.addNodes(ExpressionLogicStories);
    StoryData.addNodes(ExpressionMathStories);
    StoryData.addNodes(ExpressionStringStories);

    StoryData.addNodes(ExpressionViewStories);
    StoryData.addNodes(ExpressionViewStringStories);
    StoryData.addNodes(ExpressionViewMathStories);
    StoryData.addNodes(ExpressionViewLogicStories);

    // shared
    StoryData.addNodes(DataDefinitionEditorStories);
    StoryData.addNodes(BooleanDataEditorStories);
    StoryData.addNodes(BooleanListDataEditorStories);
    StoryData.addNodes(DataEditorStories);
    StoryData.addNodes(DataListEditorStories);
    StoryData.addNodes(FileEditorStories);
    StoryData.addNodes(FileListEditorStories);
    StoryData.addNodes(NumberEditorStories);
    StoryData.addNodes(NumberListEditorStories);
    StoryData.addNodes(StringEditorStories);
    StoryData.addNodes(StringListEditorStories);
    StoryData.addNodes(StringListValidValuesEditorStories);
    StoryData.addNodes(StringValidValuesEditorStories);
    StoryData.addNodes(ObjectEditorStories);
    StoryData.addNodes(ObjectListEditorStories);
    StoryData.addNodes(ValueOrExpressionStories);
    StoryData.addNodes(ObserveStateStories);
    StoryData.addNodes(RichTextEditorStories);
    StoryData.addNodes(InlineRichEditStories);

    // mapping
    StoryData.addNodes(MappingEditorStories);

    // property editors
    StoryData.addNodes(PropertyEditorCollapsableSectionStories);
    StoryData.addNodes(PropertyEditorExpressionStories);
    StoryData.addNodes(PropertyEditorVariableSelectionStories);
    StoryData.addNodes(PropertyEditorTypeSelectionStories);
    StoryData.addNodes(BooleanPropertyEditor);
    StoryData.addNodes(ColorPropertyEditor);
    StoryData.addNodes(DatePropertyEditor);
    StoryData.addNodes(FloatPropertyEditor);
    StoryData.addNodes(ImagePropertyEditor);
    StoryData.addNodes(IntegerPropertyEditor);
    StoryData.addNodes(SelectPropertyEditor);
    StoryData.addNodes(TextPropertyEditor);
    StoryData.addNodes(TextListPropertyEditor);
    StoryData.addNodes(PropertyEditorTextSelection);
    StoryData.addNodes(CombinedPropertyEditors);
    StoryData.addNodes(ObjectListPropertyEditorStories);
    StoryData.addNodes(CollapsePropertyEditorStories);

    // tester
    StoryData.addNodes(ExpressionTester);
    StoryData.addNodes(FormTester);
    StoryData.addNodes(IntersectionTester);
    StoryData.addNodes(RuleTableTester);
    StoryData.addNodes(StatementRuleTester);
    StoryData.addNodes(TreeRuleTester);
    StoryData.addNodes(ValueTableTester);

    // data type/variable picker
    StoryData.addNodes(DataTypePickerStories);
    StoryData.addNodes(VariablePickerStories);

    // editors
    StoryData.addNodes(InlineOptionSelectStories);
    StoryData.addNodes(InlineTextEditSelectStories);
    StoryData.addNodes(InlineMuliLineSelectStories);
    StoryData.addNodes(RichTextEditorStories);

    // flow
    StoryData.addNodes(FlowBuilderStories);
    StoryData.addNodes(FlowBuilderExpressionStepStories);
    StoryData.addNodes(FlowBuilderRuleStepsStories);
    StoryData.addNodes(FlowBuilderFormStepsStories);

    // rule
    StoryData.addNodes(IntersectionRuleStories);
    StoryData.addNodes(StatementRuleStories);
    StoryData.addNodes(RuleTableStories);
    StoryData.addNodes(TreeRuleStories);
    StoryData.addNodes(ValueTableBooleanStories);
    StoryData.addNodes(ValueTableDateStories);
    StoryData.addNodes(ValueTableNumberStories);
    StoryData.addNodes(ValueTableStringStories);
    StoryData.addNodes(ValueTableStories);

    StoryData.addNodes(CustomTextMergeBuilder);
    StoryData.addNodes(BuildlingBlockStories);

    StoryData.addNodes(OpenAIStories);
}
